import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Document = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 20px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  hr {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.neutral.cinza200};
  }
`;

export const DocumentInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h2 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }
`;

export const Files = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 10px;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
  `}
`;

export const File = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;

  width: 100%;

  padding: 10px;

  border: 1px solid ${({ theme }) => theme.colors.neutral.cinza200};
`;

export const FileInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h3 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza500};
  }
`;

export const Download = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  width: 100%;
  height: 40px;
  padding: 0 10px;

  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.primary.orange};

  h1 {
    color: ${({ theme }) => theme.colors.neutral.white};
    font-size: 14px;
  }

  :hover {
    opacity: 0.8;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;
